module.exports = __webpack_public_path__ + "img/image_7.ab60004d.jpg";